import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ToastController, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AcompanhamentoProvider } from 'src/app/services/acompanhamento/acompanhamento';
import { ConfigProvider } from 'src/app/services/config/config';
import { format, parseISO } from 'date-fns'
import { CommonModule } from '@angular/common';


import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ProverDatepickerComponent } from 'src/app/components/prover-datepicker/prover-datepicker';
import { ProverHorasComponent } from 'src/app/components/prover-horas/prover-horas.component';

@Component({
  selector: 'app-acompanhamento-reagendar',
  templateUrl: './acompanhamento-reagendar.page.html',
  styleUrls: ['./acompanhamento-reagendar.page.scss'], 
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ReactiveFormsModule,
    ProverDatepickerComponent,
    ProverHorasComponent
  ],
})
export class AcompanhamentoReagendarPage implements OnInit {
  dataFim!: string;
  horaFim!: string;
  dataIni!: string;
  horaIni!: string;
  statusList: any = [];
  acompanhamento: any = {};
  validations_form: FormGroup;
  dataHora_data: any = format(new Date(), "yyyy-MM-dd");
  dataHoraFim_data: any = format(new Date(), "yyyy-MM-dd");
  validation_messages = {
    'dataHora_data': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ],
    'dataHora_hora': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ],
    'dataHoraFim_data': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ],
    'dataHoraFim_hora': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ],
    'idAcompanhamentoStatus': [
      { type: 'required', message: this.translate.instant('Campo Obrigatório') }
    ],
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public configProvider: ConfigProvider,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    private translate: TranslateService,
    public formBuilder: FormBuilder,) {

    this.acompanhamento = this.navParams.get('acompanhamento');

    this.validations_form = this.formBuilder.group({
      dataHora_data: new FormControl('', Validators.required),
      dataHora_hora: new FormControl('', Validators.required),
      dataHoraFim_data: new FormControl('', Validators.required),
      dataHoraFim_hora: new FormControl('', Validators.required),
      idAcompanhamentoStatus: new FormControl('', Validators.required),
    });

    this.acompanhamentoProvider.getStatusReagendar().subscribe((data) => {
      this.statusList = data;
    });

    if (this.acompanhamento && this.acompanhamento.id) {
      this.carregarForm();
    }
  }

  ngOnInit() {
  }

  carregarForm() {
    this.dataFim = format(parseISO(this.acompanhamento.dataHoraFim), 'yyyy-MM-dd');
    this.horaFim = format(parseISO(this.acompanhamento.dataHoraFim), 'HH:mm');
    this.dataIni = format(parseISO(this.acompanhamento.datahora), 'yyyy-MM-dd');
    this.horaIni = format(parseISO(this.acompanhamento.datahora), 'HH:mm');

    this.validations_form.controls['dataHora_data'].setValue(this.dataIni);
    this.validations_form.controls['dataHora_hora'].setValue(this.horaIni);
    this.validations_form.controls['dataHoraFim_data'].setValue(this.dataFim);
    this.validations_form.controls['dataHoraFim_hora'].setValue(this.horaFim);
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  changeData(data: { year: string; month: string; day: string; }) {
    this.validations_form.controls['dataHoraFim_data'].setValue(data.year + '-' + data.month + '-' + data.day);
    this.dataHora_data = data.year + '-' + data.month + '-' + data.day;
  }

  changeDataPicker(data: any) {
    this.validations_form.controls['dataHoraFim_data'].setValue(data);
    this.dataHora_data = data;
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  reagendar() {
    this.validateAllFormFields(this.validations_form);

    if (this.validations_form.valid) {
      var acomp: any = {};
      acomp.idAcompanhamentoStatus = this.validations_form.value.idAcompanhamentoStatus;
      acomp.datahora = this.validations_form.value.dataHora_data + ' ' + this.validations_form.value.dataHora_hora + ':00';
      acomp.dataHoraFim = this.validations_form.value.dataHoraFim_data + ' ' + this.validations_form.value.dataHoraFim_hora + ':00';
      acomp.id = this.acompanhamento.id;

      this.acompanhamentoProvider.reagendarAcompanhamento(acomp).subscribe(async data => {
        let result = this.statusList.find((e: { id: any; }) => e.id == this.validations_form.value.idAcompanhamentoStatus);

        this.modalCtrl.dismiss({
          tipo: result.tipo,
          status: result.nome
        });

        const toast = await this.toastCtrl.create({
          message: this.translate.instant('Acompanhamento reagendado com sucesso'),
          duration: 3000
        });

        toast.present();
      });
    }
  }
}
